import { createReducer, on } from '@ngrx/store';
import { StrategicImperative } from '../../models/strategic-imperative.model';
import * as StrategicImperativesActions from './strategic-imperatives.actions';

export interface StrategicImperativesState {
  imperatives: StrategicImperative[];
  loading: boolean;
  error: any;
}

export const initialStrategicImperativesState: StrategicImperativesState = {
  imperatives: [],
  loading: false,
  error: null,
};

export const strategicImperativesReducer = createReducer(
  initialStrategicImperativesState,
  on(StrategicImperativesActions.loadStrategicImperatives, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(StrategicImperativesActions.loadStrategicImperativesSuccess, (state, { imperatives }) => ({
    ...state,
    imperatives,
    loading: false,
  })),
  on(StrategicImperativesActions.loadStrategicImperativesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(StrategicImperativesActions.addStrategicImperative, (state, { imperative: _imperative }) => ({
    ...state,
    loading: true,
  })),
  on(StrategicImperativesActions.addStrategicImperativeSuccess, (state, { imperative }) => ({
    ...state,
    imperatives: [...state.imperatives, imperative],
    loading: false,
  })),
  on(StrategicImperativesActions.addStrategicImperativeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(StrategicImperativesActions.updateStrategicImperative, (state, { id: _id, changes: _changes }) => ({
    ...state,
    loading: true,
  })),
  on(StrategicImperativesActions.updateStrategicImperativeSuccess, (state, { imperative }) => ({
    ...state,
    imperatives: state.imperatives.map((item) => (item.id === imperative.id ? imperative : item)),
    loading: false,
  })),
  on(StrategicImperativesActions.updateStrategicImperativeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

// Selectors
export const selectAllStrategicImperatives = (state: StrategicImperativesState | undefined) => state?.imperatives ?? [];
export const selectStrategicImperativesLoading = (state: StrategicImperativesState | undefined) => state?.loading ?? false;
export const selectStrategicImperativesError = (state: StrategicImperativesState | undefined) => state?.error ?? null;
